import { render } from "./HeroEditor.vue?vue&type=template&id=5c7c7ee0&scoped=true"
import script from "./HeroEditor.vue?vue&type=script&lang=js"
export * from "./HeroEditor.vue?vue&type=script&lang=js"

import "./HeroEditor.vue?vue&type=style&index=0&id=5c7c7ee0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c7c7ee0"],['__file',"src/components/pages/hero/windowOverlay/HeroEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c7c7ee0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c7c7ee0', __exports__)) {
    api.reload('5c7c7ee0', __exports__)
  }
  
  module.hot.accept("./HeroEditor.vue?vue&type=template&id=5c7c7ee0&scoped=true", () => {
    api.rerender('5c7c7ee0', render)
  })

}


export default __exports__